// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"95bd840e","576":"a396e9d7"}[chunkId] + ".chunk.js";
};